import { AuthApi } from '../../../api';
import { useContainer } from '../../useContainer';
import { LocalStorage, REFRESH_TOKEN } from '../../../util/LocalStorage';
import useHttpPostSignOut from './useHttpPostSignOut';
import { ICallback } from '../../../commonTypes/hook.types';

const useHttpPostRefreshToken = () => {
    const authApi: AuthApi = useContainer(AuthApi);
    const localStorage: LocalStorage = useContainer(LocalStorage);
    const { exec: signOut } = useHttpPostSignOut();

    const refreshToken = (callback: ICallback) => {
        const refreshToken = localStorage.get(REFRESH_TOKEN);
        if (refreshToken) {
            const { exec, abort } = authApi.refreshToken({
                body: { refreshToken },
                onSuccess: res => {
                    localStorage.setAuth(res.body);
                    callback.onSuccess && callback.onSuccess();
                },
                onError: err => {
                    signOut();
                    return err;
                },
            });
            exec();
            return abort;
        } else signOut();
    };

    return { refreshToken };
};

export default useHttpPostRefreshToken;
